import { assertNever } from '@kofno/piper';
import { ExperiencePayload } from '../../Types';

// DVLP-8168: a scheduled (epc) course is always a Scheduled Course, even when
// it has no runs to choose from, and an on-demand course never is. Coaching
// still goes by whether it has scheduled runs.
export const isScheduledCourse = (payload: ExperiencePayload): boolean => {
  switch (payload.offering_type) {
    case 'epc':
      return true;
    case 'aep':
    case 'msuite':
      return false;
    case 'coaching':
    case 'group-coaching':
    case 'program-sequence':
      return payload.program_instance_options.scheduled.length > 0;
    default:
      return assertNever(payload.offering_type);
  }
};
